import React, { useEffect, useCallback } from "react";
import UserApi from "../common/Apis/UserApi";
import { useNavigate } from "react-router-dom";
import { Button, Radio, DatePicker, Form, notification, Steps } from "antd";
import { Typography } from "antd";
import "../Questionnaire/Questionnaire.css";
import { CheckCircleFilled } from "@ant-design/icons";
import moment from "moment";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import FooterRegistraion from "../common/FooterDashboard/FooterRegistraion";

const { Title } = Typography;
const Questionnaire = (props) => {
  let navigate = useNavigate();
  const currentDate = moment();
  const [selectAnswer1, Set_Answer1] = React.useState(null);
  const [selectAnswer_2i, Set_Answer_2i] = React.useState();
  const [selectAnswer_2ii, Set_Answer_2ii] = React.useState();
  const [selectAnswer_2iii, Set_Answer_2iii] = React.useState();
  const [selectAnswer_2iv, Set_Answer_2iv] = React.useState();
  const [selectAnswer3, Set_Answer3] = React.useState(null);
  const [selectAnswer4, Set_Answer4] = React.useState(null);

  // Get User Token and Email
  const token = localStorage.getItem("userToken");
  const userEmail = localStorage.getItem("userEmail");

  const { placement } = "topRight";
  const [api, contextHolder] = notification.useNotification();

  // Update Aptitude Test Status Function
  const updateAptitudeTestStatus = useCallback(async () => {
    const formData = new FormData();
    formData.append("email", userEmail);
    formData.append(`aptitudeTestStatus`, "HEALTH_QUESTIONNAIRE");

    UserApi.updateAptitudeTestStatus(formData).catch((err) => {
      // Error Notification
      console.log(err);
      if (err) {
        api.error({
          message: `${err}`,
          placement,
        });
      }
    });
  }, [api, userEmail]);

  const tokenVerification = useCallback(() => {
    UserApi.tokenVerification(token)
      .then((response) => {
        updateAptitudeTestStatus();
      })
      .catch((err) => {
        if (err.success === false) {
          return navigate("/");
        }
      });
  }, [token, navigate, updateAptitudeTestStatus]);

  useEffect(() => {
    tokenVerification();
    // Page onLoad Scroll Top
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [tokenVerification]);
  const handleSubmit = () => {
    let formData = JSON.stringify({
      questionnaireId: 2,
      questionAndAnswerDTOList: [
        {
          question:
            "Have you suffered from diarrhoea and vomiting within the last 48 hours?",
          answer: `${selectAnswer1}`,
        },
        {
          question: "Infected wounds, skin infections or sores",
          answer: `${selectAnswer_2i}`,
        },
        {
          question: "Boils, styes or septic fingers?",
          answer: `${selectAnswer_2ii}`,
        },
        {
          question: "Discharge from eye, ear or gums/mouth?",
          answer: `${selectAnswer_2iii}`,
        },
        {
          question: "Jaundice",
          answer: `${selectAnswer_2iv}`,
        },
        {
          question:
            "Have you ever had or are you known to be a carrier of typhoid or paratyphoid",
          answer: `${selectAnswer3}`,
        },
        {
          question:
            "In the last 21 days have you been in contact with anyone, at home or abroad, who may have been suffering from typhoid or paratyphoid",
          answer: `${selectAnswer4}`,
        },
      ],
      email: userEmail,
    });
    QuestionnairesApi.QuestionSetsAnswer(formData)
      .then((response) => {
        return navigate("/register");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Registration  Steps
  const items = [
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 1</p>
            <h4>
              <b>Induction</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 2</p>
            <h4>
              <b>MCQ Test</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 3</p>
            <h4>
              <b>Protective Clothing</b>
            </h4>
            <p className="Compleletd">Compleletd</p>
          </div>
        </>
      ),
      status: "finish",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 4</p>
            <h4>
              <b>Health Questionnaire</b>
            </h4>
            <p className="process">In Progress</p>
          </div>
        </>
      ),
      status: "process",
    },
    {
      description: (
        <>
          <div className="stepsLayout">
            <p className="step">Step 5</p>
            <h4>
              <b>Registraion</b>
            </h4>
            <p>Pending</p>
          </div>
        </>
      ),
      status: "wait",
    },
  ];

  const customDot = (dot, { status }) => {
    switch (status) {
      case "finish":
        return <CheckCircleFilled />;
      case "process":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      case "wait":
        return (
          <>
            <div className="circle-step">
              <div id="outer-circle">
                <div id="inner-circle"></div>
              </div>
            </div>
          </>
        );
      default:
        return dot;
    }
  };
  return (
    <>
      {" "}
      <div
        className="logo-title"
        style={{ boxShadow: "3px 3px 10px -4px rgba(0, 0, 0, 0.1)" }}
      >
        <img
          src="/assest/Images/Logo/logo.png"
          className="logo-png"
          style={{ width: "14%" }}
        />
      </div>
      <div className="container form-container pt-3">
        {contextHolder}
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-10 col-md-12 px-0">
            <Steps
              current={3}
              labelPlacement="vertical"
              items={items}
              progressDot={customDot}
            />
          </div>
          <Title className="sub-title text-center pt-5">
            Health Questionnaire
          </Title>
          <div className="col-xl-9 col-lg-9 col-md-12 p-0 pb-5 d-flex">
            <div className="card-body">
              <>
                <div className="question-border">
                  <Form
                    name="nest-messages"
                    layout="vertical"
                    onFinish={handleSubmit}
                  >
                    <>
                      <div className="Questionnaire-Clothing">
                        <Form.Item
                          name="protectiveDate"
                          label="Date"
                          className="text-lable col-lg-6 col-sm-12 col-md-7"
                        >
                          <DatePicker
                            type="date"
                            format="DD/MM/YYYY"
                            defaultValue={currentDate}
                            placeholder="DD/MM/YY"
                            className="form-control control-input"
                            disabled
                          />
                        </Form.Item>
                      </div>
                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          1. Have you suffered from diarrhoea and vomiting
                          within the last 48 hours?
                        </p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer1 === true}
                            onChange={() => Set_Answer1(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer1 === false}
                            onChange={() => Set_Answer1(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>
                      {selectAnswer1 === false && (
                        <>
                          <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                            <p className="Health-question">
                              Have you in the last 48 hours taken any medication
                              to control diarrhoea and vomiting ?
                            </p>
                          </div>
                          <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                            <ul className="remember-p">
                              <Radio className="healthQuestion">Yes</Radio>
                              <Radio className="healthQuestion">No</Radio>
                            </ul>
                          </Form.Item>
                        </>
                      )}
                      <div className="text-lable col-lg-5 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          2. At present are you suffering from:
                        </p>
                        <p className="Health-question">
                          i. infected wounds, skin infections or sores?
                        </p>
                      </div>
                      <Form.Item
                        className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2"
                        rules={[
                          {
                            required: true,
                            message: "The input is not valid E-mail!",
                          },
                        ]}
                      >
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2i === true}
                            onChange={() => Set_Answer_2i(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2i === false}
                            onChange={() => Set_Answer_2i(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>
                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          ii. boils, styes or septic fingers?
                        </p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2ii === true}
                            onChange={() => Set_Answer_2ii(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2ii === false}
                            onChange={() => Set_Answer_2ii(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>
                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          iii. discharge from eye, ear or gums/mouth?
                        </p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2iii === true}
                            onChange={() => Set_Answer_2iii(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2iii === false}
                            onChange={() => Set_Answer_2iii(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>
                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">iv. jaundice</p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2iv === true}
                            onChange={() => Set_Answer_2iv(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer_2iv === false}
                            onChange={() => Set_Answer_2iv(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>

                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          3. Have you ever had or are you known to be a carrier
                          of typhoid or paratyphoid?
                        </p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer3 === true}
                            onChange={() => Set_Answer3(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer3 === false}
                            onChange={() => Set_Answer3(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>

                      <div className="text-lable col-lg-12 col-sm-12 col-md-7 pt-4">
                        <p className="Health-question">
                          4. In the last 21 days have you been in contact with
                          anyone, at home or abroad, who may have been suffering
                          from typhoid or paratyphoid?
                        </p>
                      </div>
                      <Form.Item className="text-lable col-lg-6 col-sm-12 col-md-7 pt-2">
                        <ul className="remember-p">
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer4 === true}
                            onChange={() => Set_Answer4(true)}
                          >
                            Yes
                          </Radio>
                          <Radio
                            className="healthQuestion"
                            checked={selectAnswer4 === false}
                            onChange={() => Set_Answer4(false)}
                          >
                            No
                          </Radio>
                        </ul>
                      </Form.Item>

                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary btn-submit"
                        disabled={
                          selectAnswer1 !== null &&
                          selectAnswer_2i !== null &&
                          selectAnswer_2ii !== null &&
                          selectAnswer_2iii !== null &&
                          selectAnswer_2iv !== null &&
                          selectAnswer4 !== null &&
                          selectAnswer3 !== null
                            ? false
                            : true
                        }
                      >
                        Finish
                      </Button>
                    </>
                  </Form>
                </div>
              </>
            </div>
          </div>
        </div>
        <FooterRegistraion />
      </div>
    </>
  );
};

export default Questionnaire;
